import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IUpdateParentalLockUseCase {
    execute(
        apiKey: string,
        identityToken: string,
        epochMs: string,
        encPassword: string,
        newEncLock: string
    ): Promise<any>;
}

export class UpdateParentalLockUseCase implements IUpdateParentalLockUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        identityToken: string,
        epochMs: string,
        encPassword: string,
        newEncLock: string
    ): Promise<any> {
        const result = await this.profileRepository.updateParentalLock(
            apiKey,
            identityToken,
            epochMs,
            encPassword,
            newEncLock
        );
        return result.data;
    }
}
